import { render, staticRenderFns } from "./PrecalificacionesSoc.vue?vue&type=template&id=36125cf4&scoped=true&"
import script from "./PrecalificacionesSoc.vue?vue&type=script&lang=js&"
export * from "./PrecalificacionesSoc.vue?vue&type=script&lang=js&"
import style0 from "./PrecalificacionesSoc.vue?vue&type=style&index=0&id=36125cf4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36125cf4",
  null
  
)

export default component.exports